import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65e9dcc7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "format-input"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "input-container width" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "mm", -1))
const _hoisted_5 = { class: "input-container height" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "mm", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exchange-alt" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.internalFormat)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              class: "input is-small",
              spellcheck: "false",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalFormat.width) = $event))
            }, null, 512), [
              [
                _vModelText,
                _ctx.internalFormat.width,
                void 0,
                { number: true }
              ]
            ]),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              class: "input is-small",
              spellcheck: "false",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.internalFormat.height) = $event))
            }, null, 512), [
              [
                _vModelText,
                _ctx.internalFormat.height,
                void 0,
                { number: true }
              ]
            ]),
            _hoisted_6
          ]),
          _hoisted_7,
          _createElementVNode("button", {
            class: "swap-button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.swap()))
          }, _hoisted_9)
        ])
      ]))
    : _createCommentVNode("", true)
}